<div class="wrapper cv-dialog-form organization-container">
	<div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="config.nexsysLenderCompanyId = $event.value.trim()"
				[value]="config.nexsysLenderCompanyId"
				[label]="'LenderCompanyId'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[placeholder]="'LenderCompanyId'"
			></cv-input>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="config.appScopeMessage = $event.value.trim()"
				[value]="config.appScopeMessage"
				[label]="'AppScope'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[placeholder]="'AppScope'"
			></cv-input>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="config.acuityMessage = $event.value.trim()"
				[value]="config.acuityMessage"
				[label]="'Acuity'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[placeholder]="'Acuity'"
			></cv-input>
		</div>
	</div>

	<div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="config.cmpAcuityMessage = $event.value.trim()"
				[value]="config.cmpAcuityMessage"
				[label]="'CMP Acuity'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[placeholder]="'CMP Acuity'"
			></cv-input>
		</div>
	</div>
</div>
